export const changeOrders = state => state.changeOrders.items
export const changeOrdersByProjectId = state => id => _.filter(state.changeOrders.items, {project_id: parseInt(id)})
export const changeOrderById = state => id => _.find(changeOrders(state), {id})
export const changeOrdersByIds = state => ids => {
    return _.reduce(ids, (res, id) => {
        let item = changeOrderById(state)(id)
        if (item) res.push(item)
        return res
    }, [])
}
export const changeOrderMessage = state => {
    return `
Hello [contact.full_name],<br><br>We have created a change order for you. The PDF is attached to this email,
please sign and send back to us so that we can proceed. Feel free to
contact us with any questions.<br><br>[docusign_link]<br><br>Please let us know if you have any questions.
    `
}

export const changeOrderRemindMessage = state => {
    return `
    Hello [contact.full_name],
    I just wanted to check on the status of the change order for [project.full_name] sent over on [date] for our expediting services.  Is it still under consideration or should I drop this particular change order on our end?
    <br><br>
    [docusign_link]
    <br><br>
    If you have any questions concerning our change order or if there's anything else we can help you with, please don't hesitate to contact us.
    `
}

export const negativeChangeOrderMessage = state => {
    return `
Hello [contact.full_name],<br><br>We have created a negative change order for you. The PDF is attached to this email,
please sign and send back to us so that our records are updated. Feel free to
contact us with any questions.<br><br>[docusign_link]<br><br>Please let us know if you have any questions.
    `
}
